import { render, staticRenderFns } from "./GenericSeoForm.vue?vue&type=template&id=d4483de8&"
import script from "./GenericSeoForm.vue?vue&type=script&lang=js&"
export * from "./GenericSeoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports